const mutations = {
  showMessage(state, payload) {
    state.width = payload.width;
    state.lock = payload.lock;
    state.subject = payload.subject;
    state.content = payload.content;
    state.footer = payload.footer;
    state.show = true;
  },
  closeMessage(state) {
    state.show = false;
  },
  nextMessage(state) {
    state.index += 1;
  },
  thisMessage(state, request) {
    state.index = request;
  },
  setPeriod(state, request) {
    state.isPeriod = request;
  },
  setShow(state, request) {
    state.show = request;
  },
  addQueue(state, request) {
    if (state.queue.indexOf(request) === -1) state.queue.push(request);
  },
  removeQueue(state, request) {
    const index = state.queue.indexOf(request);
    if (index > -1) state.queue.splice(index, 1);
  },
};

const getters = {
};

const actions = {
  nextMessage({ commit }) {
    commit('nextMessage');
  },
  thisMessage({ commit }, request) {
    commit('thisMessage', request);
  },
  setPeriod({ commit }, request) {
    commit('setPeriod', request);
  },
  setShow({ commit }, request) {
    commit('setShow', request);
  },
  addQueue({ commit }, request) {
    commit('addQueue', request);
  },
  removeQueue({ commit }, request) {
    commit('removeQueue', request);
  },
};

const state = {
  index: 0,
  show: false,
  queue: [],
  isPeriod: false,
  lock: false,
  subject: '',
  content: '',
  footer: null,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
